import { SettingConst } from '@faire/web-api--source/types';

/**
 * Controls whether or not we call home-retailer APIs on direct load for logged out search/discover page
 */
export const NEXTJS_CALLS_HOME_RETAILER_APIS_SEARCH_250422 =
  'NEXTJS_CALLS_HOME_RETAILER_APIS_SEARCH_250422' as SettingConst<
    'NEXTJS_CALLS_HOME_RETAILER_APIS_SEARCH_250422',
    boolean,
    'RETAILER' | 'VISITOR_WEB'
  >;
